import React from 'react';

import { gettext } from '@eb/i18n-ebspa';

import FilterPanel from './FilterPanel';
import AnimatedDrawer from '../animatedDrawer/AnimatedDrawer';

import { Icon } from '@eb/eds-icon';
import { Button } from '@eb/eds-button';
import { ChevronDownChunky as ChevronDownChunkySvg } from '@eb/eds-iconography';

import './FilterPanelMobile.scss';

const DoneButton = ({ openCloseAnimatedDrawer }) => (
    <Button
        size="block"
        style="fill"
        onClick={() => openCloseAnimatedDrawer(false)}
        data-integration="filter-panel-mobile--done-btn"
    >
        {gettext('Done')}
    </Button>
);

const FilterPanelMobile = (props) => {
    const applyFilter = (key, val, shouldUpdateRoute) => {
        //If filter is being applied, val !== all. In that case we
        //want to render the general filters view
        if (val !== 'all') {
            props.openCloseAnimatedDrawer(true, '', false);
        }

        props.onFilterChange(key, val, shouldUpdateRoute);
    };

    return (
        <AnimatedDrawer>
            <FilterPanel
                {...props}
                isMobile={true}
                renderPanelHeaderAction={() => (
                    <span className="filter-title--mobile__panel-close-btn">
                        <Button
                            style="none"
                            onClick={() => props.openCloseAnimatedDrawer(false)}
                            title="Close filter panel"
                            data-integration="filter-title__panel-close-btn"
                        >
                            <Icon
                                type={<ChevronDownChunkySvg />}
                                size="medium"
                                color="grey-800"
                            />
                        </Button>
                    </span>
                )}
                stickyFooter={
                    !props.filterTypeToShow && (
                        <DoneButton
                            openCloseAnimatedDrawer={
                                props.openCloseAnimatedDrawer
                            }
                        />
                    )
                }
                onFilterChange={(...args) => applyFilter(...args)}
                handleDrawerSelect={(val) =>
                    props.openCloseAnimatedDrawer(true, val, false)
                }
            />
        </AnimatedDrawer>
    );
};
export default FilterPanelMobile;
